import ApiConfig from "@/utils/constants/api-config";
const Constants = Object.freeze({
    api: ApiConfig.api,
    endpointList : {
        "kichwaTranslate" : ApiConfig.api+"/translate",
        "kichwaError" : ApiConfig.api+"/translate/error",
        "compileAndRun": ApiConfig.api+"/compileAndRun",
        "register": ApiConfig.api+"/register",
        "login": ApiConfig.api+"/login",
        "userProfile": ApiConfig.api+"/profile",
        "getUser": ApiConfig.api+"/profile/getUser",
        "courseStatus": ApiConfig.api+"/course/userStatus",
        "subscribeCourse":ApiConfig.api+"/course/subscribe",
        "nextLevel": ApiConfig.api+"/course/nextLevel",
        "complete": ApiConfig.api+"/course/complete",
        "certificate":ApiConfig.api+"/course/certificates",
        "docs":ApiConfig.api+"/course/docs",
    },

})

export default  Constants;
